import { klickartPerformantIframe } from 'src/performant/setIframe'

window.addEventListener('load', klickartPerformantIframe)
